module.exports = __webpack_public_path__ + "static/media/invoice-white.fdea3e4a.svg";